module.exports = __webpack_public_path__ + "img/198646.ccda543b.png";